import React, { useState } from 'react'
import styled from 'styled-components'

import { pageContext } from 'context'
import { Page } from 'schema'
import { PopOut, Button, Icon } from 'components'
import { PageIcon, PageOptions } from 'features'
import { FaEllipsisH, FaFileAlt } from 'react-icons/fa'

import classes from './PageBlock.module.css'

const defaultStyle = {
    size: '1rem',
    fontSize: '0.9rem',
    backgroundColor: 'var(--secondary-color)',
    borderBottom: null,
    borderRadius: '5px',
    padding: '0 0.5rem'
}

const Container = styled.div`

    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${props => props.styles.padding};
    border-radius: ${props => props.styles.borderRadius};
    background-color: ${props => props.styles.backgroundColor};
    opacity: ${props => props.isDragging && '0.5'};
    /* background-color: ${props => props.selected ? 'var(--primary-accent-color)' : 'var(--secondary-color)'}; */
    cursor: pointer;
    min-height: 2rem;
    :hover {
        filter: brightness(var(--brightness));
    }
`

const ContentContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 4;
    padding: 0.5rem 0;
`

const IconContainer = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    /* height: 0.5rem; */
`

const Title = styled.div`
    /* font-weight: bolder; */
    font-size: ${props => props.styles.fontSize};
    line-height: ${props => props.styles.fontSize};
    margin-left: 0.25rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 8rem;
    height: 100%;
`

const TileContainer = styled.div`
    background-color: var(--primary-color);
    border-radius: 5px;
    cursor: pointer;
    padding: 1rem;
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-column-gap: 0.5rem;
    align-items: center;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const TileTitle = styled.div`
    font-size: 1rem;
    /* font-weight: bold; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const Wrapper = styled.div`
    border-radius: 5px;
    border: ${props => !props.border ? null 
                    : props.focus ? '2px solid var(--focus-color)' 
                    : '2px solid transparent'};
`

const PageBlock = props => {
    const [hover, hoverState] = React.useState(false);
    const {
        page,
        selected,
        onSelect,
        style,
        disableButtons,
        focus,
        border,
        ref,
        type,
        isDragging
    } = props;
    let updatedStyle = Object.assign({}, defaultStyle, style)
    let titleStyle = {...updatedStyle}
    titleStyle['borderBottom'] = null
    titleStyle['padding'] = null

    const buttonStyle ={
        backgroundColor: updatedStyle['backgroundColor'],
        color:'var(--secondary-accent-color)',
        hoverColor:'var(--text-color)',
        margin:'0rem',
        padding:'0.3rem',
        fontSize:'0.7rem',
        boxShadowColor: 'transparent'
    }

    switch(type) {
        case 'TILE':
            return (
                <PopOut trigger={!disableButtons && 'rightClick'} point={true} element={<PageOptions page={page}/>}>
                    <TileContainer onClick={onSelect} styles={updatedStyle} onMouseEnter={() => {!disableButtons && hoverState(true)}} onMouseLeave={() => {!disableButtons && hoverState(false)}} selected={selected}>
                        <Icon styles={{backgroundColor: 'transparent', padding: 0}} cursor='pointer' size={'1.5rem'} value={page.icon ? page.icon.value : null} type={page.icon ? page.icon.type : null}/>
                        <TileTitle>{page.page_name}</TileTitle>
                        {hover ? <Button icon={<FaEllipsisH/>} contextMenu={<PageOptions page={page}/>} styles={buttonStyle}/> : null}
                    </TileContainer>
                </PopOut>
            )
        default:
            return (
                <PopOut trigger={!disableButtons && 'rightClick'} point={true} element={<PageOptions page={page}/>}>
                    <Wrapper border={border} focus={focus} ref={ref}>
                        <Container isDragging={isDragging} styles={updatedStyle} onMouseEnter={() => {!disableButtons && hoverState(true)}} onMouseLeave={() => {!disableButtons && hoverState(false)}} selected={selected}>
                            <ContentContainer onClick={onSelect}>
                                <IconContainer>
                                    <Icon styles={{backgroundColor: 'transparent', padding: 0}} size={updatedStyle.size} value={page.icon ? page.icon.value : null} type={page.icon ? page.icon.type : null}/>
                                </IconContainer>
                                <Title styles={titleStyle}>{page.page_name}</Title>
                            </ContentContainer>
                            {hover ? <Button icon={<FaEllipsisH/>} contextMenu={<PageOptions page={page}/>} styles={buttonStyle}/> : null}
                        </Container>
                    </Wrapper>
                </PopOut>
            )
    }
}

export default PageBlock;